const footerLinks = [
  { label: '会社概要', href: '#company' },
  { label: '事業内容', href: '#business' },
  { label: 'エントリー・お問い合わせ', href: '#entry' },
];

export default function Footer() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer
      className="w-full"
      style={{
        backgroundColor: '#FFFFFF',
        borderTop: '1px solid rgba(168,205,217,0.4)',
        paddingTop: '60px',
        paddingBottom: '40px',
      }}
      aria-label="フッター"
    >
      <div className="max-w-4xl mx-auto px-6 lg:px-10 flex flex-col items-center gap-8">
        {/* Logo */}
        <a
          href="#"
          onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
          className="cursor-pointer"
          aria-label="株式会社Universe トップへ"
        >
          <img
            src="https://storage.readdy-site.link/project_files/2eebd179-5ab9-4607-b0cd-6c7581f8e0aa/3d2cf485-900e-4930-b64e-e729cce20055_Universe.png?v=1cd2231bd8f54e77057a499a35c5ec79"
            alt="株式会社Universe ロゴ"
            className="h-9 w-auto object-contain"
            style={{
              background: 'transparent',
              border: 'none',
              boxShadow: 'none',
            }}
          />
        </a>

        {/* Nav links */}
        <nav className="flex flex-wrap justify-center gap-8 lg:gap-12">
          {footerLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => { e.preventDefault(); handleClick(link.href); }}
              className="text-xs font-light tracking-widest transition-colors duration-300 cursor-pointer whitespace-nowrap"
              style={{
                color: '#555',
                letterSpacing: '0.15em',
                fontFamily: "'Noto Sans JP', sans-serif",
              }}
              onMouseEnter={(e) => { (e.currentTarget as HTMLAnchorElement).style.color = '#B89B4A'; }}
              onMouseLeave={(e) => { (e.currentTarget as HTMLAnchorElement).style.color = '#555'; }}
            >
              {link.label}
            </a>
          ))}
        </nav>

        {/* Social / Contact links */}
        <div className="flex items-center gap-8">
          <a
            href="mailto:universe.inc42@gmail.com"
            className="flex items-center gap-2 text-xs font-light transition-colors duration-300 cursor-pointer"
            style={{ color: '#777', letterSpacing: '0.1em' }}
            onMouseEnter={(e) => { (e.currentTarget as HTMLAnchorElement).style.color = '#B89B4A'; }}
            onMouseLeave={(e) => { (e.currentTarget as HTMLAnchorElement).style.color = '#777'; }}
            aria-label="メールで問い合わせ"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-mail-line text-sm" />
            </span>
            <span className="hidden sm:inline">MAIL</span>
          </a>

          <a
            href="https://www.instagram.com/inc.universe?igsh=MTRhaXYwbTdyY3R2cQ%3D%3D&utm_source=qr"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-xs font-light transition-colors duration-300 cursor-pointer"
            style={{ color: '#777', letterSpacing: '0.1em' }}
            onMouseEnter={(e) => { (e.currentTarget as HTMLAnchorElement).style.color = '#B89B4A'; }}
            onMouseLeave={(e) => { (e.currentTarget as HTMLAnchorElement).style.color = '#777'; }}
            aria-label="Instagram"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-instagram-line text-sm" />
            </span>
            <span className="hidden sm:inline">Instagram</span>
          </a>

          <a
            href="https://lin.ee/ZHvBTbt"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-xs font-light transition-colors duration-300 cursor-pointer"
            style={{ color: '#777', letterSpacing: '0.1em' }}
            onMouseEnter={(e) => { (e.currentTarget as HTMLAnchorElement).style.color = '#B89B4A'; }}
            onMouseLeave={(e) => { (e.currentTarget as HTMLAnchorElement).style.color = '#777'; }}
            aria-label="LINE"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-line-fill text-sm" />
            </span>
            <span className="hidden sm:inline">LINE</span>
          </a>
        </div>

        {/* Divider */}
        <div
          className="w-full"
          style={{ height: '1px', backgroundColor: 'rgba(168,205,217,0.4)' }}
        />

        {/* Copyright */}
        <p
          className="text-xs font-light text-center"
          style={{
            color: '#999',
            letterSpacing: '0.1em',
            fontFamily: "'Montserrat', sans-serif",
          }}
        >
          © 2026 株式会社Universe. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
